import { useMutation } from 'react-query';

import { generateResignedTokens } from '../../lib/api';

export function useMutateGenerateResignedTokens() {
  return useMutation(generateResignedTokens);
}
